import { Channel, ChannelDescriptor, Client as ChatClient } from 'twilio-chat'
import { graphQLClient } from './authService'
import chatQueries from './graphql/chatQueries'

class ChatService {
  getToken = async (): Promise<string> => {
    const response = await graphQLClient.request(chatQueries.getToken)
    return response.chatToken
  }

  getChannels = async () => {
    const token = await this.getToken()
    const client = await ChatClient.create(token)

    client.on('tokenAboutToExpire', () => {
      this.getToken().then((token: any) => {
        if (token) {
          client.updateToken(token)
        }
      })
    })

    client.on('tokenExpired', () => {
      this.getToken().then((token: any) => {
        if (token) {
          client.updateToken(token)
        }
      })
    })

    const paginator = await client.getSubscribedChannels()
    return paginator.items as unknown as ChannelDescriptor[]
  }

  getMessagesByChannel = async (channel: Channel) => {
    const newMessages = await channel.getMessages(50)

    const fullMessages = newMessages.items.map(async (message, index) => {
      let mediaUrl
      if (message.type === 'media') {
        mediaUrl = await message.media.getContentTemporaryUrl()
      }

      return {
        sid: message.sid,
        body: message.body,
        mediaFilename: message.media && message.media.filename,
        mediaSize: message.media && message.media.size,
        mediaType: message.media && message.media.contentType,
        mediaUrl: mediaUrl,
        author: message.author,
        created: message.dateCreated,
        lastMessage: newMessages.items.length === index + 1,
      }
    })

    return await Promise.all(fullMessages)
  }
}

const chatService = new ChatService()

export default chatService
